// src/components/ModeSwitcher.js
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./modeswitcher.css";

export default function ModeSwitcher() {
  const location = useLocation();
  const isNewApp   = location.pathname === "/";
  const isOldApp   = location.pathname === "/old";
  const isVroomApp = location.pathname === "/vroom";
  const [logoLoaded, setLogoLoaded]   = useState(false);
  const [logoError, setLogoError]     = useState(false);
  const [showAbout, setShowAbout]     = useState(false);

  return (
    <>
      <header className="mode-header">
        <div className="mode-container">

          {/* Left: BUW logo + app title */}
          <div className="mode-brand">
            {!logoError ? (
              <img
                src="/buw-logo.png"
                alt="Bergische Universität Wuppertal"
                className="mode-buw-logo"
                style={{ display: logoLoaded ? 'block' : 'none' }}
                onLoad={() => setLogoLoaded(true)}
                onError={() => setLogoError(true)}
              />
            ) : null}
            {(!logoLoaded || logoError) && (
              <div className="mode-buw-logo-placeholder">
                Bergische<br />Universität<br />Wuppertal
              </div>
            )}
            <div className="mode-divider" />
            <h1 className="mode-title">
              RouteGrid Analyzer
            </h1>
          </div>

          {/* Right: navigation */}
          <nav className="mode-nav">
            <Link to="/"      className={`mode-link ${isNewApp   ? "active" : ""}`}>OSRM Grid</Link>
            <Link to="/old"   className={`mode-link ${isOldApp   ? "active" : ""}`}>Routing App</Link>
            <Link to="/vroom" className={`mode-link ${isVroomApp ? "active" : ""}`}>Vroom</Link>
            <button className="mode-link mode-about-btn" onClick={() => setShowAbout(true)}>About</button>
          </nav>

        </div>
      </header>

      {/* ── About modal ── */}
      {showAbout && (
        <div className="about-overlay" onClick={() => setShowAbout(false)}>
          <div className="about-card" onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div className="about-header">
              <img src="/buw-logo.png" alt="BUW" className="about-logo"
                onError={e => e.target.style.display = 'none'} />
              <div>
                <h2 className="about-title">RouteGrid Analyzer</h2>
                <p className="about-subtitle">Bergische Universität Wuppertal</p>
              </div>
              <button className="about-close" onClick={() => setShowAbout(false)}>✕</button>
            </div>

            {/* Body */}
            <div className="about-body">

              <p className="about-desc">
                A geo-routing research tool for analysing urban and regional transportation networks.
                It combines open-source routing engines with grid-based spatial data to support
                logistics research, travel-time analysis, and vehicle route optimisation.
              </p>

              {/* Three apps */}
              <div className="about-apps">
                <div className="about-app">
                  <span className="about-app-icon">⬡</span>
                  <div>
                    <strong>OSRM Grid</strong>
                    <p>Select grid cells, export distance matrices as CSV, and generate travel-time isochrones coloured by the Viridis scale.</p>
                  </div>
                </div>
                <div className="about-app">
                  <span className="about-app-icon">🗺</span>
                  <div>
                    <strong>Routing App</strong>
                    <p>Upload coordinate CSVs and compute point-to-point routes and travel-time tables via OSRM for car, truck, and bicycle profiles.</p>
                  </div>
                </div>
                <div className="about-app">
                  <span className="about-app-icon">🚛</span>
                  <div>
                    <strong>Vroom App</strong>
                    <p>Place vehicles and jobs interactively on the map and solve vehicle routing problems (VRP) using the Vroom optimisation engine.</p>
                  </div>
                </div>
              </div>

              {/* Tech stack */}
              <div className="about-section">
                <h3 className="about-section-title">Built with</h3>
                <div className="about-tags">
                  {['OSRM','Vroom','React','Leaflet','OpenStreetMap','PostgreSQL','Docker','nginx'].map(t => (
                    <span key={t} className="about-tag">{t}</span>
                  ))}
                </div>
              </div>

              {/* Contact */}
              <div className="about-section about-contact">
                <h3 className="about-section-title">Contact</h3>
                <div className="about-contact-row">
                  <span className="about-contact-icon">🏛</span>
                  <div>
                    <strong>Bergische Universität Wuppertal</strong><br />
                    LuF Güterverkehrsplanung und Transportlogistik
                  </div>
                </div>
                <div className="about-contact-row">
                  <span className="about-contact-icon">✉</span>
                  <div>
                    <a href="mailto:abdullateef871@gmail.com" className="about-email">
                      Lateef Abdul (abdullateef871@gmail.com)
                    </a> <br />
                    <a href="mailto:fgross@uni-wuppertal.de" className="about-email">
                      Florian Groß (fgross@uni-wuppertal.de)
                    </a> <br />
                    <a href="mailto:schlott@uni-wuppertal.de" className="about-email">
                      Marian Schlott (schlott@uni-wuppertal.de)
                    </a>
                  </div>
                </div>
                <div className="about-contact-row">
                  <span className="about-contact-icon">🌐</span>
                  <div>
                    <a href="https://gut.uni-wuppertal.de/de/" target="_blank" rel="noreferrer" className="about-email">
                      www.gut.uni-wuppertal.de
                    </a>
                  </div>
                </div>
              </div>

            </div>

            <div className="about-footer">
              Data © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer" className="about-email">OpenStreetMap</a> contributors
            </div>

          </div>
        </div>
      )}
    </>
  );
}
